import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useTranslation } from "react-i18next";

export const RightsAccordion = () => {
  const { t } = useTranslation();

  const accordionItems = [
    {
      title: t("rights.items.0.title"),
      content: t("rights.items.0.content"),
    },
    {
      title: t("rights.items.1.title"),
      content: t("rights.items.1.content"),
    },
    {
      title: t("rights.items.2.title"),
      content: t("rights.items.2.content"),
    },
    {
      title: t("rights.items.3.title"),
      content: t("rights.items.3.content"),
    },
  ];

  return (
    <div className="bg-[#F7F7F7] py-20">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-left mb-12 text-[#bc943e]">
          {t("rights.title")}
        </h2>
        <Accordion 
          type="single" 
          collapsible 
          className="mx-auto space-y-4"
        >
          {accordionItems.map((item, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="bg-white rounded-lg shadow-sm border border-gray-200"
            >
              <AccordionTrigger className="px-6 py-4 text-left text-lg font-semibold text-[#333333] hover:text-[#F5A623] hover:no-underline">
                {item.title}
              </AccordionTrigger>
              <AccordionContent className="px-6 pb-4 text-[#666666] text-base leading-relaxed">
                {item.content}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
};